/**
 * List of events used by dates filter widget
 *
 */
export const datesFilter = {
  DATES_FILTERS_APPLIED: 'DatesFilter.FilterApplied'
}
